import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedGameData} from "../../../server/data/WGParsedGameData";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {WGGameConfig} from "../../../WGGameConfig";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../../WGSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {WarriorGraveyard} from "../../../WarriorGraveyard";

export class WarriorFeatureWinPresentation extends Presentation {
    private _warriorFeatureData: WGParsedGameData;

    public checkForActivation(data: WGParsedGameData): boolean {
        return data.triggerWarriorPay;
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._warriorFeatureData = data;
    }
    private getWinNumberText(amt: number): string {
        let str: string = Currency.formatValue(amt);
        return str;
    }

    private getWinWaysCont(betLineData: IBetLineWinData): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        const winNumber:  PIXI.BitmapText = new PIXI.BitmapText(this.getWinNumberText(betLineData.multipliedAmount),  {
            fontName: "WGNumbersWinCountUp",
            fontSize: 8
        });
        while (winNumber.width > GameConfig.instance.SYMBOL_WIDTH) {
            --winNumber.fontSize;
        }
        winNumber.pivot.set(winNumber.width/2,winNumber.height/2);
        cont.addChild(winNumber);
        cont.visible=false;
        return cont;
    }

    public getPresentation(): void {
        let reelsToShowWinBoxes: number[] = [];
        for (let i: number = 0; i < WGGameConfig.instance.REEL_ENGINE_CONFIG.REEL_AMOUNT; i++) {
            if (this._warriorFeatureData.activeWarriorSymbolReel[i] || this._warriorFeatureData.wildMultipliers[i] > 0 || this._warriorFeatureData.lockedWildReelsAfter[i]) {
                reelsToShowWinBoxes.push(i);
            }
        }
        if(WarriorGraveyard.api.gameClientConfiguration.displayIndividualWinsInGame){
            const betLineWins = <IBetLineWinData[]>(this._warriorFeatureData.triggerWarriorPay?this._warriorFeatureData.warriorBetLineWins:this._warriorFeatureData.betWins);
            betLineWins.forEach((betLineWinData, idx) => {
                const durr: number = this.pTimeline.duration();
                let con: PIXI.Container;
                con = this.getWinWaysCont(betLineWinData);
                StageManager.getLayer(WGGameConfig.instance.LAYERS.INDI_SYM_WIN.name).addChild(con);
                this.pTimeline.add( WarriorGraveyardGameModuleConfig.betlineWinBox.playWinBoxAnimationForSymIndiWin(betLineWinData,con).timeScale(3),durr);

                this.pTimeline.add(() => {
                    con.visible=true;
                }, durr);

                this.pTimeline.add(() => {
                    StageManager.getLayer(WGGameConfig.instance.LAYERS.INDI_SYM_WIN.name).removeChild(con);
                });
            })
            this.pTimeline.add(()=>{
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
            })
        }else {
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        }

        this.pTimeline.add(WarriorGraveyardGameModuleConfig.betlineWinBox.showAllBetlinesOneByOne());
        if (this._warriorFeatureData.isBigWin) {
            this.pTimeline.add(() => {
                SoundManager.playSoundEffect(WGSoundConfig.instance.BIG_WIN_INITIAL_WIN_SOUND);
                SoundManager.fadeAmbienceLoop(0, 2500);
            });
        }

        for (let i: number = 1; i < 5; i++) { // to fix #323
            if (this._warriorFeatureData.wildMultipliers[i] > 0 || this._warriorFeatureData.lockedFSWildMultiplier[i] !== -1) {
                this.pTimeline.add(() => WarriorGraveyardGameModuleConfig.stackAnimationPlayer
                    .playWildStackAnimation(i, "_win"));
            }
        }

        this.pTimeline.add(() => WarriorGraveyardGameModuleConfig.stackAnimationPlayer
            .playAliveMidStackWinAnimation(this._warriorFeatureData.activeWarriorSymbolReel, this._warriorFeatureData.triggerWarriorSymbol));

        this.pTimeline.add(WarriorGraveyardGameModuleConfig.betlineWinBox.showWinBoxForWarriorFeaturePresentation(reelsToShowWinBoxes));

        if (!this._warriorFeatureData.betWins.length && !this._warriorFeatureData.isBigWin) {
            const totalWin: number = this._warriorFeatureData!.singleWin;
            const from: number = 0;
            const duration: number = this._warriorFeatureData!.currentWinRatioConfig!.duration;
            this.pTimeline.add(() => SlotGame.winFieldController.showWinField());
        }

        this.pTimeline.add(() => {
            WarriorGraveyardGameModuleConfig.stackAnimationPlayer.hideALlWinMidStack();
            this.PresentationState.set(PresentationState.END);
        }, this.pTimeline.duration() + 1);
    }

    /**
     * override this function to handle skip
     */
    public endPresentation(): void {
        this.pTimeline.totalProgress(1);
        this.stopPresentation();
    }

    /**
     * stopPresentation
     */
    public stopPresentation(): void {
        WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllWinBox();
        WarriorGraveyardGameModuleConfig.betlineWinBox.hideAllBetlines();
        this.PresentationState.set(PresentationState.INACTIVE);
    }
}